export default __webpack_public_path__ + "static/logo-5-2f277d52ba4b4adf4f08d5c399454749.png";